<script>
import firebase from 'firebase'
import { mapActions, mapGetters } from 'vuex'
import { emailRule, passwordRule } from '../../helpers/validationRules'
import api from '../../api'
import ButtonLoading from '@/components/buttons/Button.vue'

export default {
  name: 'Login',
  metaInfo: {
    title: 'Login',
    titleTemplate: '%s | LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'LinkBook.io makes life easier to find and access your favourite websites instantly.'
      }
    ]
  },
  components: {
    ButtonLoading
  },
  data() {
    return {
      isLoading: false,
      email: null,
      password: null,
      feedback: null,
      showPassword: false,
      emailRule,
      passwordRule
    }
  },
  computed: {
    ...mapGetters(['authTokenRefererUrl', 'refererUrl'])
  },
  methods: {
    ...mapActions(['login', 'finalizeLogin']),
    async submit(e) {
      e.preventDefault()
      this.isLoading = false
      if (this.email && this.password) {
        this.isLoading = true
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(async () => {
            try {
              await api.profileUpdate({
                loggedIn: firebase.firestore.Timestamp.fromDate(new Date())
              })
            } catch (error) {
              console.error('Profile update on login failed:', error)
            }

            return this.finalizeLogin()
              .then(() => {
                // Prioritize redirection: first check if there's an auth token URL
                if (this.authTokenRefererUrl) {
                  this.$router.push(this.authTokenRefererUrl)
                }
                // Then check if the refererUrl exists and is not a login/signup page
                else if (
                  this.refererUrl &&
                  this.refererUrl !== '/' &&
                  !this.refererUrl.startsWith('/login') &&
                  !this.refererUrl.startsWith('/signup') &&
                  !this.refererUrl.startsWith('/forgotpassword')
                ) {
                  this.$router.push(this.refererUrl)
                } else {
                  this.$router.push('/dashboard')
                }
              })
              .catch(error => {
                console.error('Login finalization error:', error)
                this.feedback = 'Login failed. Please try again.'
                this.isLoading = false
              })
          })
          .catch(err => {
            this.feedback = err.message
            this.isLoading = false
          })
        this.feedback = null
      } else {
        this.feedback = 'Please fill in both fields'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  max-width: 400px;
  margin-top: 60px;
  h2 {
    font-size: 2.4em;
  }
  .field {
    margin-bottom: 16px;
  }
}
</style>

<template>
  <v-card width="400" class="mx-auto mt-16">
    <v-card-title>
      <h1 class="display-1">Login</h1>
    </v-card-title>
    <v-card-text>
      <v-form @submit="submit">
        <v-text-field
          name="email"
          label="Email"
          v-model="email"
          prepend-icon="mdi-account-circle"
          :rules="emailRule"
          required
        />
        <v-text-field
          name="password"
          label="Password"
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          prepend-icon="mdi-lock"
          @click:append="showPassword = !showPassword"
          :rules="passwordRule"
          required
        />
        <v-card-actions>
          <p v-if="feedback" class="my-3 red--text center">{{ feedback }}</p>
          <v-spacer></v-spacer>
          <a href="/forgotpassword">Forgot Password</a>
        </v-card-actions>

        <v-divider class="my-3"></v-divider>
        <v-card-actions>
          <router-link to="/signup">Create a new account?</router-link>
          <v-spacer></v-spacer>

          <ButtonLoading color="primary" :disabled="isLoading" type="submit">
            Login
          </ButtonLoading>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>
